import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

export const PaginationSeparatorWrapper = styled.div`
  width: 32px;
  margin-top: ${Spacing.S4};
  text-align: center;
`
